import { useEffect, useRef } from "react";
import { X, Mouse, Footprints } from "lucide-react";

export default function WalkMode({ worldRef, onExit }) {
  const exitRef = useRef(onExit);
  exitRef.current = onExit;

  useEffect(() => {
    const ref = worldRef;
    ref.current?.setWalk(true);
    const onEsc = (e) => { if (e.key === "Escape") exitRef.current?.(); };
    window.addEventListener("keydown", onEsc);
    return () => { window.removeEventListener("keydown", onEsc); ref.current?.setWalk(false); };
    // Intentionally run once: re-running would teleport the player back to spawn.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="walk-mode" className="absolute inset-0 z-40 pointer-events-none select-none">
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-5 h-5">
        <span className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-cyan-300/70" />
        <span className="absolute inset-y-0 left-1/2 w-px -translate-x-1/2 bg-cyan-300/70" />
        <span className="absolute inset-0 rounded-full border border-cyan-300/40" />
      </div>

      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 50%, transparent 58%, rgba(5,3,20,0.55) 100%)" }} />

      <div data-testid="walk-hint" className="absolute top-4 left-1/2 -translate-x-1/2 px-3 py-1.5 rounded-lg bg-black/55 border border-white/10 font-mono text-[11px] text-cyan-200 flex items-center gap-2">
        <Mouse size={13} /> Click to look · W/A/S/D move · Shift run · E enter building
      </div>

      <button data-testid="walk-exit" onClick={onExit} className="pointer-events-auto absolute top-4 right-4 flex items-center gap-1.5 px-3 h-9 rounded-xl bg-white/10 hover:bg-white/20 border border-white/10 text-zinc-100 text-xs font-tactical font-bold uppercase transition-colors">
        <X size={15} /> Exit
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 text-cyan-200/70 text-[11px] font-mono">
        <Footprints size={13} className="text-cyan-400" /> Walking your real city at street level
      </div>
    </div>
  );
}
